/**
 * @ngdoc service
 * @name myrReserveDeviceService
 * @description
 * get SalesForce iFrame URL
 *
 * */

(function () {
  'use strict';
  angular
    .module('eclipseApp.reserveDevice')
    .factory('uteReserveDeviceService', _service);

  _service.$inject = ['env'];

  /* @ngInject */
  function _service(env) {

    var service = {
      loadSalesForceUrl: loadSalesForceUrl
    };
    return service;


    function loadSalesForceUrl() {
      var iFrameUrl = '';
      if (env.salesForceUrl) {

        iFrameUrl = env.salesForceUrl;
      }
      return iFrameUrl;
    }
  }
})();

